import { useMemo } from "react";
import useFetchGraphData from "../useFetchGraphData";

const LOCS = { CC10: 68, CT2: 83 };
const MONTHS = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export default function useInflowComparisonSeries({
  parameterid,
  years,
  flowcond,
}) {
  const {
    data,
    isFetching: isLoading,
    isError,
  } = useFetchGraphData(
    {
      parameterid,
      years: years.join(","),
      flowcond,
    },
    "wq-inflow-comparison" // <-- stable react-query key + route
  );

  const { cc10, ct2, unit } = useMemo(() => {
    if (!data?.length)
      return { cc10: { series: [] }, ct2: { series: [] }, unit: "" };

    const build = (rows, locId) => {
      const unit = rows[0]?.unit_name ?? "";
      const yearSet = new Set(years.map(Number));
      const template = MONTHS.map((m) => ({ month: m }));

      rows
        .filter((r) => r.locationid === locId && yearSet.has(r.year))
        .forEach((r) => {
          const entry = template.find((d) => d.month === r.month); // use r.month string
          if (entry) entry[r.year] = r.rvalue;
        });

      const vals = rows
        .filter((r) => r.locationid === locId)
        .map((r) => r.rvalue);

      const extent = [0, Math.max(...vals, 0) * 1.05];

      return { series: template, extent, unit };
    };

    return {
      cc10: build(data, LOCS.CC10),
      ct2: build(data, LOCS.CT2),
      unit: data[0].unit_name,
    };
  }, [data, years]);

  return { cc10, ct2, unit, isLoading, isError };
}
